import PropTypes from 'prop-types'
import { memo, useMemo } from 'react'
import Content from 'components/content/Content/Content'
import Button from 'components/core/Button/Button'
import AdaptiveImage from 'components/elements/AdaptiveImage/AdaptiveImage'
import Modal from 'components/interface/Modal/Modal'
import { capitalizeFirstWord } from 'lib/util/string'
import styles from './ModalBrandView.module.scss'

/**
 * The `ModalMediaBrand`
 *
 * @param {object} props - the component props
 * @returns {React.ReactElement} the element
 */
function ModalMediaBrand (props) {
  const { description, image, links, title } = props

  const outputTitle = useMemo(() => <h1>{title}</h1>, [])
  const content = useMemo(
    () => [
      {
        type: 'standard',
        align: 'center',
        content: `<p>${description}</p>`
      }
    ],
    []
  )
  const linksOutput = useMemo(() => {
    if (!links || !links.length) {
      return null
    }

    return (
      <ul className={styles.links}>
        {links.map((link, i) => (
          <li key={i}>
            <Button
              key={i}
              type="symbol"
              color="e"
              Tag="a"
              icon={link?.type?.toLowerCase()}
              href={link?.url}
              target="_blank"
              title={capitalizeFirstWord(link?.type)}
            />
          </li>
        ))}
      </ul>
    )
  }, [links])

  return (
    <Modal.Container size="small">
      <Modal.Media>
        <AdaptiveImage src={image} title={title} />
      </Modal.Media>
      <Modal.Header>{outputTitle}</Modal.Header>
      <Modal.Body>
        <Content items={content} />
        {linksOutput}
      </Modal.Body>
      <Modal.Footer />
    </Modal.Container>
  )
}

/** @type {object} */
ModalMediaBrand.propTypes = {
  description: PropTypes.string,
  id: PropTypes.string,
  links: PropTypes.arrayOf(PropTypes.shape()),
  image: PropTypes.string,
  title: PropTypes.string
}

/** @type {object} */
ModalMediaBrand.defaultProps = {
  description: '',
  id: '',
  links: [],
  image: '',
  title: ''
}

// Memoize
export default memo(ModalMediaBrand)
